import { Button, notification } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { findAll } from 'services/unidadeBasicaService';
import { reload, updateStatusEtapa } from 'store/ducks/etapa';
import constantes from 'utils/constantes';
import { internarPaciente } from 'store/ducks/paciente';
import SectionDescricao from '../../Sections/SectionDescricao';
import Etapa from '../../TemplateEtapa';
import SectionUnidade from '../../Sections/SectionUnidade';

function Footer({ etapa, propriedades }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    async function execute() {
      setLoading(true);
      await dispatch(
        updateStatusEtapa(constantes.ETAPA.STATUS.EXECUTADO, propriedades)
      );
      await dispatch(internarPaciente(propriedades.unidade));
      await dispatch(reload());
      setLoading(false);
    }
    if (!propriedades.unidade) {
      notification.warn({
        message: 'Unidade de Internação não selecionada.',
      });
    } else {
      execute();
    }
  }, [dispatch, propriedades]);

  if (etapa.status === constantes.ETAPA.STATUS.NAO_EXECUTADO) {
    return (
      <Button
        loading={loading}
        className="btn-green"
        icon="check"
        onClick={handleClick}
        size="large">
        Confirmar isolamento
      </Button>
    );
  }
  return null;
}

export default function EtapaQuarentena({ etapa }) {
  const [hospitais, setHospitais] = useState([]);
  const [propriedades, setPropriedades] = useState({});

  useEffect(() => {
    findAll({ internacao: true }).then(respHosp => {
      setHospitais(respHosp.data);
    });
  }, []);

  const handleChangeProperties = useCallback(data => {
    setPropriedades(prev => ({ ...prev, ...data }));
  }, []);

  const footer = useMemo(() => {
    return <Footer etapa={etapa} propriedades={propriedades} />;
  }, [etapa, propriedades]);

  return (
    <Etapa
      etapa={etapa}
      sections={[
        <SectionDescricao etapa={etapa} />,
        <SectionUnidade
          etapa={etapa}
          hospitais={hospitais}
          onChange={handleChangeProperties}
        />,
      ]}
      footer={[footer]}
    />
  );
}
